import {
  getNotificationPerPage,
  deleteNotification,
  updateNotification,
  sendNotificationToUser,
} from '@/apis/notification';
import dayjs from '@/plugins/dayjs';
import { NOTIFICATIONS } from '../mutation-types';

export const state = {
  listAllNotification: [],
  listUnreadNotification: [],
  lastPageAllNotifications: 0,
  lastPageUnreadNotifications: 0,
  currentPageAll: 0,
  currentPageUnread: 0,
  totalUnread: 0,
  sendNotification: '',
};

export const getters = {
  allNotifications: (state) => state.listAllNotification,
  unreadNotifications: (state) => state.listUnreadNotification,
  lastPageAllNotifications: (state) => state.lastPageAllNotifications,
  lastPageUnreadNotifications: (state) => state.lastPageUnreadNotifications,
  totalUnread: (state) => state.totalUnread,
};

export const mutations = {
  [NOTIFICATIONS.SEND_NOTIFICATION_TO_USER](state, data) {
    state.sendNotification = data;
  },
  [NOTIFICATIONS.GET_ALL_NOTIFICATIONS](state, data) {
    if (!data?.error) {
      state.lastPageAllNotifications = data.last_page;
      if (data.data.length && state.currentPageAll < data.current_page) {
        state.listAllNotification = [...state.listAllNotification, ...data.data].sort((item, el) => {
          return dayjs(el.received_date) - dayjs(item.received_date);
        }).map(el => { return { ...el, is_delete: false }; });
        state.currentPageAll = data.current_page;
      }
    }
  },
  [NOTIFICATIONS.GET_UNREAD_NOTIFICATIONS](state, data) {
    if (!data?.error) {
      state.lastPageUnreadNotifications = data.last_page;
      if (data.data.length && state.currentPageUnread < data.current_page) {
        state.listUnreadNotification = [...state.listUnreadNotification, ...data.data].sort((item, el) => {
          return dayjs(el.received_date) - dayjs(item.received_date);
        }).map(el => { return { ...el, is_delete: false }; });
        state.currentPageUnread = data.current_page;
      }
    }
  },
  [NOTIFICATIONS.GET_TOTAL_UNREAD_NOTIFICATIONS](state, data) {
    state.totalUnread = data.total || 0;
  },
  [NOTIFICATIONS.UPDATE_NOTIFICATION](state, data) {
    state.listAllNotification = state.listAllNotification.map(el => {
      if (el.id === data) {
        return { ...el, read_flag: 1 };
      }
      return el;
    });
    state.listUnreadNotification = state.listUnreadNotification.filter(el => el.id !== data);
    if (state.totalUnread) {
      state.totalUnread -= 1;
    }
  },
  [NOTIFICATIONS.RECEIVE_NEW_NOTIFICATION](state, data) {
    state.totalUnread += 1;
  },
  [NOTIFICATIONS.CLEAR_DATA_NOTIFICATIONS](state, data) {
    state.listAllNotification = state.listAllNotification.filter(el => el.id !== data.item.id);
    if (!data.item.read_flag) {
      state.listUnreadNotification = state.listUnreadNotification.filter(el => el.id !== data.item.id);
      if (state.totalUnread) {
        state.totalUnread -= 1;
      }
    }
  },
  [NOTIFICATIONS.CLEAR_LIST_NOTIFICATIONS](state, data) {
    state.listAllNotification = [];
    state.listUnreadNotification = [];
    state.lastPageAllNotifications = 0;
    state.lastPageUnreadNotifications = 0;
    state.currentPageAll = 0;
    state.currentPageUnread = 0;
  },
};

export const actions = {
  async getNotificationAll({ commit }, page) {
    const data = { current: page || 1, read_flag: 1 };
    const res = await getNotificationPerPage(data);
    commit(NOTIFICATIONS.GET_ALL_NOTIFICATIONS, res);
  },
  async getNotificationUnread({ commit }, page) {
    const data = { current: page || 1, read_flag: 0 };
    const res = await getNotificationPerPage(data);
    commit(NOTIFICATIONS.GET_UNREAD_NOTIFICATIONS, res);
  },
  async getTotalNotificationUnread({ commit }) {
    const data = { current: 1, read_flag: 0 };
    const res = await getNotificationPerPage(data);
    commit(NOTIFICATIONS.GET_TOTAL_UNREAD_NOTIFICATIONS, res);
  },
  async updateNotification({ commit }, dataId) {
    const data = {
      id: dataId,
      read_flag: 1
    };
    await updateNotification(data);
    commit(NOTIFICATIONS.UPDATE_NOTIFICATION, dataId);
  },
  async undoNotification({ commit }, dataId) {
    const data = {
      id: dataId,
      deleted_at: 0
    };
    await updateNotification(data);
  },
  async receiveNewNotification({ commit }) {
    commit(NOTIFICATIONS.RECEIVE_NEW_NOTIFICATION);
  },
  async deleteNotification({ commit }, id) {
    await deleteNotification(id);
  },
  async clearDeleteNotification({ commit }, data) {
    commit(NOTIFICATIONS.CLEAR_DATA_NOTIFICATIONS, data);
  },
  async clearListNotifications({ commit }) {
    commit(NOTIFICATIONS.CLEAR_LIST_NOTIFICATIONS);
  },
  async sendNotification({ commit }, payload) {
    const res = await sendNotificationToUser(payload);
    commit(NOTIFICATIONS.SEND_NOTIFICATION_TO_USER, res);

    return res;
  },
};
